export default function About() {
  return (
    <section id="about-section" className="py-20 bg-zinc-900">
      <div className="max-w-7xl mx-auto px-6">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl font-bold text-white mb-8">
            Company Overview
          </h2>
          <p className="text-gray-300 leading-relaxed text-base">
            ZJF IT Services LLC is a New York-based IT deployment and field services company specializing in workstation rollouts, structured cabling, network installations, and office IT relocations. We partner with MSPs, integrators, and enterprise teams that require reliable on-site execution across NYC and nationwide.
          </p>
        </div>
      </div>
    </section>
  );
}
